unable to read source [project]/packages/src/utils/pointerDrag.ts